import { render } from "./budgetexpenses-model.vue?vue&type=template&id=81d64892"
import script from "./budgetexpenses-model.vue?vue&type=script&lang=js"
export * from "./budgetexpenses-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__